import { authRoles } from '@/core'
import { RouteRecordRaw } from 'vue-router'

const { ADMIN, MANUFACTURE } = authRoles

const Scraps = () =>
  import(/* webpackChunkName: "login-view" */ './views/pages/index.vue')

export const scrapsModuleRoutes: Array<RouteRecordRaw> = [
  {
    path: '/scraps',
    name: 'scraps',
    component: Scraps,
    meta: {
      title: 'Scraps',
      auth: {
        roles: [ADMIN, MANUFACTURE],
        redirect: '/auth/login',
        notFoundRedirect: { name: '/404' },
        forbiddenRedirect: '/404',
      },
    },
  },
]
